import HeroSection from "../../components/client-side/homepage/HeroSection";
import FeaturedCasinos from "../../components/client-side/homepage/FeaturedCasinos";
import ExploreSection from "../../components/client-side/homepage/ExploreSection";
import TrustSection from "../../components/client-side/homepage/TrustSection";
import NewsSection from "../../components/client-side/homepage/NewsSection";
import NewsletterTestimonials from "../../components/client-side/homepage/NewsletterTestimonials";
import ContactSection from "../../components/client-side/homepage/ContactSection";

const HomePage = () => {
  return (
    <div className="bg-background dark:bg-darkbg text-textLight dark:text-textDark transition-colors duration-300">
      <main>
        {/* Hero Section */}
        <HeroSection />

        {/* Featured Casinos */}
        <FeaturedCasinos />

        {/* Explore Section */}
        <ExploreSection />

        {/* Trust Section */}
        <TrustSection />

        {/* News Section */}
        <NewsSection />

        {/* Newsletter & Testimonials */}
        <NewsletterTestimonials />

        {/* Contact Section */}
        <ContactSection />
      </main>
    </div>
  );
};

export default HomePage;
